'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _body = require('./body');

var _body2 = _interopRequireDefault(_body);

var _head = require('./head');

var _head2 = _interopRequireDefault(_head);

var _getColumns = require('./getColumns');

var _getColumns2 = _interopRequireDefault(_getColumns);

var _getNextSortDirection = require('./getNextSortDirection');

var _getNextSortDirection2 = _interopRequireDefault(_getNextSortDirection);

require('./styles.css');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * Data tables display information in a way that’s easy to scan,
 * so that users can look for patterns and insights.
 * @category DataView
 */


var Table = function (_Component) {
  _inherits(Table, _Component);

  function Table(props) {
    _classCallCheck(this, Table);

    var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));

    _this.state = {
      columns: (0, _getColumns2.default)(props.children),
      tableWidth: undefined
    };
    _this.handleSort = _this.handleSort.bind(_this);
    _this.handleResize = _this.handleResize.bind(_this);
    _this.tableRef = _react2.default.createRef();
    return _this;
  }

  _createClass(Table, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(_ref) {
      var prevChildren = _ref.children;
      var currentChildren = this.props.children;

      if (prevChildren !== currentChildren) {
        this.getUpdatedColumns();
      }
    }
  }, {
    key: 'getContainerClassNames',
    value: function getContainerClassNames() {
      var className = this.props.className;
      return (0, _classnames2.default)('rainbow-table_wrapper', className);
    }
  }, {
    key: 'getUpdatedColumns',
    value: function getUpdatedColumns() {
      var children = this.props.children;
      var newColumns = (0, _getColumns2.default)(children);
      this.setState({
        columns: newColumns
      });
    }
  }, {
    key: 'handleResize',
    value: function handleResize(plusWidth) {
      var tableWidth = this.state.tableWidth;

      if (tableWidth) {
        return this.setState({
          tableWidth: tableWidth + plusWidth
        });
      }

      var _tableRef$current$get = this.tableRef.current.getBoundingClientRect(),
          initialWidth = _tableRef$current$get.width;

      return this.setState({
        tableWidth: initialWidth + plusWidth
      });
    }
  }, {
    key: 'handleSort',
    value: function handleSort(event, field, sortDirection) {
      var _props = this.props,
          onSort = _props.onSort,
          sortedBy = _props.sortedBy;
      var nextSortDirection = (0, _getNextSortDirection2.default)(field, sortedBy, sortDirection);
      onSort(event, field, nextSortDirection);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          data = _props2.data,
          sortedBy = _props2.sortedBy,
          sortDirection = _props2.sortDirection,
          defaultSortDirection = _props2.defaultSortDirection,
          resizeColumnDisabled = _props2.resizeColumnDisabled,
          minColumnWidth = _props2.minColumnWidth,
          maxColumnWidth = _props2.maxColumnWidth,
          style = _props2.style;
      var _state = this.state,
          columns = _state.columns,
          tableWidth = _state.tableWidth;
      var tableStyles = {
        width: tableWidth
      };
      return _react2.default.createElement('div', {
        className: this.getContainerClassNames(),
        style: style
      }, _react2.default.createElement('div', {
        className: 'rainbow-table_container--scrollable-x'
      }, _react2.default.createElement('div', {
        className: 'rainbow-table_container--scrollable-y',
        style: tableStyles
      }, _react2.default.createElement('table', {
        className: 'rainbow-table',
        style: tableStyles,
        ref: this.tableRef
      }, _react2.default.createElement('thead', null, _react2.default.createElement('tr', null, _react2.default.createElement(_head2.default, {
        columns: columns,
        selectedColumn: sortedBy,
        sortDirection: sortDirection,
        defaultSortDirection: defaultSortDirection,
        resizeColumnDisabled: resizeColumnDisabled,
        minColumnWidth: minColumnWidth,
        maxColumnWidth: maxColumnWidth,
        onSort: this.handleSort,
        onResize: this.handleResize
      }))), _react2.default.createElement('tbody', {
        className: 'rainbow-table_body'
      }, _react2.default.createElement(_body2.default, {
        data: data,
        columns: columns
      }))))));
    }
  }]);

  return Table;
}(_react.Component);

exports.default = Table;
Table.propTypes = {
  /** An array containing the objects(rows) to be displayed. */
  data: _propTypes2.default.arrayOf(Object).isRequired,

  /** The column fieldName that controls the sorting order.
   * Sort the data using the onsort event handler. */
  sortedBy: _propTypes2.default.string,

  /**
   * Specifies the sorting direction, valid options are 'asc' or 'desc'.
   */
  sortDirection: _propTypes2.default.oneOf(['asc', 'desc']),

  /** Specifies the default sorting direction on an unsorted column.
   * Valid options include 'asc' and 'desc'.
   * The default is 'asc' for sorting in ascending order. */
  defaultSortDirection: _propTypes2.default.oneOf(['asc', 'desc']),

  /** Action triggered when a column is sorted.
   * Receive the event object, field and sortDirection. */
  onSort: _propTypes2.default.func,

  /** Specifies whether column resizing is disabled. The default is false. */
  resizeColumnDisabled: _propTypes2.default.bool,

  /** The minimum width for all columns. The default is 50px. */
  minColumnWidth: _propTypes2.default.number,

  /** The maximum width for all columns. The default is 1000px. */
  maxColumnWidth: _propTypes2.default.number,

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes2.default.string,

  /** An object with custom style applied for the outer element. */
  style: _propTypes2.default.object,

  /**
   * This prop that should not be visible in the documentation.
   * @ignore
   */
  children: _propTypes2.default.node
};
Table.defaultProps = {
  sortedBy: undefined,
  sortDirection: undefined,
  defaultSortDirection: 'asc',
  onSort: function onSort() {},
  resizeColumnDisabled: false,
  minColumnWidth: 50,
  maxColumnWidth: 1000,
  className: undefined,
  style: undefined,
  children: undefined
};